import React, { useState, useEffect } from "react";
import { API_URL } from "../../../constants";
import { Table } from "react-bootstrap";
import moment from "moment";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../services/serviceCaller";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";
import { useDispatch } from "react-redux";
import { FaSpinner } from "react-icons/fa";
import { useNavigate, useParams } from "react-router-dom";

const EmpFeedBackForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  const { id } = useParams();

  useEffect(() => {
    dispatch(
      updateNavbarHeading("Project Resource Evaluation – Manager Feedback")
    );
  }, []);

  useEffect(() => {
    fetchOpts();
  }, []);

  const [formData, setFormData] = useState({});
  console.log("formData:::", formData);

  const [formTemplate, setFormTemplate] = useState([]);
  const [error, setError] = useState({});
  const [empHeaderData, setEmpHeaderData] = useState({});
  console.log("empHeaderData:::", empHeaderData);
  const [feedbackData, setFeedbackData] = useState([]);
  const [empListData, setEmpListData] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isPageLoading, setPageLoading] = useState(false);
  const fetchOpts = async () => {
    setPageLoading(true);
    try {
      const response = await GetServiceCaller(
        `${API_URL}preview-feedback-questions/${id}`
      );
      if (response?.status === 200) {
        setPageLoading(false);
        setEmpHeaderData(response?.data?.data?.feedbacklog || {});
        setFeedbackData(response?.data?.data?.feedbacklog || []);
        setEmpListData(
          response?.data?.data?.employee?.map((el) => ({
            value: el?.value,
            label: el?.text,
          })) || []
        );

        const cycleDetails = response?.data?.data?.questions || [];
        setFormTemplate(cycleDetails);

        const initialFormData = {};
        cycleDetails.forEach((question) => {
          initialFormData[question.ID] = {
            answer: question.EmployeeAnswer || "",
            EmployeeRating: question.EmployeeRating || "0",
            selectedOptionLabel: question.EmployeeAnswer
              ? [question.EmployeeAnswer]
              : [],
          };
        });

        setFormData(initialFormData);
      } else if (response?.status === 202) {
          setPageLoading(false);
          // toast.error(response?.data?.message);
      } else {
        // setPageLoading(false);
        toast.error(response?.data?.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("Failed to load form data");
    }
  };

  const validateForm = () => {
    const newErrors = {};

    formTemplate.forEach((question) => {
      const response = formData[question.ID];
      const rating = Number(response?.EmployeeRating || 0);

      const maxValue = Number(question.Weightage) || 10; // fallback if null

      if (question.QuestionType_202 === 1343) {
        if (!rating || rating <= 0) {
          newErrors[question.ID] = "Please select an option";
        }
      } else if (question.QuestionType_202 === 1342) {
        // if (!response?.answer || response.answer.length < 10) {
        //   newErrors[question.ID] =
        //     "Please provide a detailed response (min. 10 characters)";
        // }

        // ✅ Rating check with safe fallback
        // if (isNaN(rating) || rating <= 0 || rating > maxValue) {
        //   newErrors[
        //     `${question.ID}_rating`
        //   ] = `Rating must be greater than 0 and less than or equal to ${maxValue}`;
        // }
      }
    });

    setError(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleTextChange = (e, questionId) => {
    const newText = e.target.value;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [questionId]: {
        ...prevFormData[questionId],
        answer: newText,
      },
    }));

    if (newText.length > 0 && newText.length < 10) {
      setError((prevError) => ({
        ...prevError,
        [questionId]: `Please lengthen text to 10 or more characters (you are currently using ${newText.length} characters).`,
      }));
    } else {
      setError((prevError) => {
        const newError = { ...prevError };
        delete newError[questionId];
        return newError;
      });
    }
  };
  const handleRatingChange = (e, questionId) => {
    const value = e.target.value;
    const rating = Number(value);

    // get max weightage from the formTemplate
    const maxValue = Number(
      formTemplate.find((q) => q.ID === questionId)?.Weightage || 10
    );

    setFormData((prevFormData) => ({
      ...prevFormData,
      [questionId]: {
        ...prevFormData[questionId],
        EmployeeRating: value,
      },
    }));

    // if (isNaN(rating) || rating <= 0 || rating > maxValue) {
    //   setError((prevError) => ({
    //     ...prevError,
    //     [`${questionId}_rating`]: `Please provide a rating between 1 and ${maxValue}`,
    //   }));
    // } else {
    //   setError((prevError) => {
    //     const newError = { ...prevError };
    //     delete newError[`${questionId}_rating`];
    //     return newError;
    //   });
    // }
  };

  const handleRadioChange = (e, questionId, optionLabel, item) => {
    const selectedValue = e.target.value;

    setFormData((prevFormData) => ({
      ...prevFormData,
      [questionId]: {
        ...prevFormData[questionId],
        EmployeeRating: selectedValue,
        selectedOptionLabel: [optionLabel], // Store the selected option key, e.g., 'Option4'
      },
    }));

    setError((prevError) => {
      const newError = { ...prevError };
      delete newError[questionId];
      return newError;
    });
  };

  const handleEmployeeSubmit = async (e, isDraft = false) => {
    e.preventDefault();
    setIsSubmitting(true);

    if (!isDraft && !validateForm()) {
      toast.error(
        "Please complete all required fields correctly before submitting."
      );
      setIsSubmitting(false);
      return;
    }

    const formattedData = formTemplate.map((question) => {
      const response = formData[question.ID];
      let employeeAnswer = "";
      let employeeRating = "0";

      if (question.QuestionType_202 === 1342) {
        // Textarea or open-ended question
        employeeAnswer = response?.answer || "";
        employeeRating = response?.EmployeeRating || "0";
      } else if (question.QuestionType_202 === 1343) {
        // Radio button question
        employeeRating = response?.EmployeeRating || "0";

        // Use selectedOptionLabel to get correct answer
        if (response?.selectedOptionLabel?.[0]) {
          const selectedKey = response.selectedOptionLabel[0]; // e.g., 'Option4'
          employeeAnswer = question[selectedKey] || "";
        }
      }

      return {
        ID: question.ID,
        QuestionType_202: question.QuestionType_202,
        EmployeeAnswer: employeeAnswer,
        EmployeeRating: employeeRating,
      };
    });

    const payload = {
      EmployeeID: empHeaderData?.EmpID || null,
      ReviewDate: moment().format("YYYY-MM-DD"),
      TotalRating: formattedData.reduce(
        (acc, curr) => acc + (parseFloat(curr.EmployeeRating) || 0),
        0
      ),
      FeedbackID: id || null,
      lines: formattedData.map((item) => ({
        QuestionID: item.ID,
        QuestionType_202: item.QuestionType_202,
        EmployeeAnswer: item.EmployeeAnswer,
        Rating: item.EmployeeRating,
      })),
    };

    console.log("Submission payload:", payload);

    try {
      const response = await PostServiceCaller(
        `${API_URL}post-feedback-questions`,
        payload,
        "post"
      );

      if (response.status === 200) {
        toast.success(
          isDraft
            ? "Saved as draft successfully!"
            : "Feedback Provided Successfully!"
        );
        navigate('/')
        // Optional: reset form or redirect
      } else {
        throw new Error(`Server returned status ${response.status}`);
      }
    } catch (error) {
      console.error("Submission error:", error);
      toast.error(
        error.response?.data?.message ||
        "Error submitting form data. Please try again."
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  if (isPageLoading) {
    return (
      <p className="position-absolute top-50 start-50 translate-middle text-center">
        <FaSpinner className="spinner" />
      </p>
    );
  }
  return (
    <div className="container-fluid" id="skill_section">
      {!feedbackData || feedbackData === "" || feedbackData.length === 0 ? (
        // Case 1: Feedback already submitted
        <div className="container-fluid" id="skill-table-area">
          <div className="text-center p-2">
            <h4>Feedback Has Already Been Provided!</h4>
          </div>
        </div>
      ) : (
        // Case 2: Show form if data exists
        <div className="container-fluid" id="skill-table-area">
          {/* Employee Details */}
          <div className="row mt-3 ">
            <div className="gap-5 d-flex flex-wrap">
              {/* Employee Name */}
              <div className="ms-2">
                <label htmlFor="employeeName" className="form-label">
                  Employee
                </label>
                <input
                  type="text"
                  id="employeeName"
                  value={
                    empListData.find((el) => el.value === empHeaderData?.EmpID)
                      ?.label || ""
                  }
                  className="form-control"
                  disabled
                />
              </div>

              {/* Manager Name */}
              <div>
                <label htmlFor="managerName" className="form-label">
                  Manager
                </label>
                <input
                  type="text"
                  id="managerName"
                  value={
                    empListData.find(
                      (el) => el.value === empHeaderData?.ManagerID
                    )?.label || ""
                  }
                  className="form-control"
                  disabled
                />
              </div>

              {/* Feedback Date */}
              <div>
                <label htmlFor="feedbackDate" className="form-label">
                  Current Date
                </label>
                <input
                  type="text"
                  id="feedbackDate"
                  value={
                    moment().format("DD-MMM-YYYY") // Today's date as default
                  }
                  className="form-control"
                  disabled
                />
              </div>
            </div>
          </div>
          {/* Form Template */}
          <div className="row mt-2">
            <div className="col-md-12">
              <div className="box-body container-fluid px-2">
                {/* Form Title */}
                {/* <h5 className="fw-bold text-center">Manager Feedback Form</h5> */}

                <form onSubmit={(e) => handleEmployeeSubmit(e, false)}>
                  {formTemplate.map((question, index) => (
                    <div
                      key={question.ID}
                      className="card mb-3 shadow-sm rounded-3"
                      style={{ backgroundColor: "#dfe2e6" }}
                    >
                      {/* Card Header */}
                      <div
                        className="card-header fw-bold text-white"
                        style={{ backgroundColor: "#27568c" }}
                      >
                        {index + 1}) {question.Title}
                      </div>

                      {/* Card Body */}
                      <div className="card-body">
                        {/* Question Text */}
                        <p className="text-muted fw-bold ps-3">
                          {question.Question}
                        </p>

                        {/* Textarea + Rating */}
                        {question.QuestionType_202 === 1342 && (
                          <div className="mb-3 ps-3">
                            <textarea
                              className={`form-control ${error[question.ID] ? "is-invalid" : ""
                                }`}
                              onChange={(e) => handleTextChange(e, question.ID)}
                              value={formData[question.ID]?.answer || ""}
                              style={{ backgroundColor: "#f3f3f3" }}
                              rows={3}
                              placeholder="Please provide your answer here..."
                            />
                            {error[question.ID] && (
                              <div className="text-danger mt-1">
                                {error[question.ID]}
                              </div>
                            )}

                            <div className="mt-2" style={{ maxWidth: "120px" }}>
                              <input
                                type="number"
                                // min="1"
                                // max="10"
                                // step="0.5"
                                placeholder="Rating (1-10)"
                                value={
                                  formData[question.ID]?.EmployeeRating || ""
                                }
                                className={`form-control ${error[`${question.ID}_rating`]
                                    ? "is-invalid"
                                    : ""
                                  }`}
                                style={{ backgroundColor: "#f3f3f3" }}
                                onChange={(e) =>
                                  handleRatingChange(e, question.ID)
                                }
                              />
                              {error[`${question.ID}_rating`] && (
                                <div className="text-danger mt-1">
                                  {error[`${question.ID}_rating`]}
                                </div>
                              )}
                            </div>
                          </div>
                        )}

                        {/* Radio Options */}
                        {question.QuestionType_202 === 1343 && (
                          <div className="mb-3 ps-3">
                            {[
                              {
                                option: question.Option1,
                                weightage: question.OptionWeightage1,
                              },
                              {
                                option: question.Option2,
                                weightage: question.OptionWeightage2,
                              },
                              {
                                option: question.Option3,
                                weightage: question.OptionWeightage3,
                              },
                              {
                                option: question.Option4,
                                weightage: question.OptionWeightage4,
                              },
                            ].map(
                              (item, idx) =>
                                item.option && (
                                  <div
                                    className="form-check ps-3 mb-1"
                                    key={idx}
                                  >
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name={`question-${question.ID}`}
                                      value={item.weightage}
                                      onChange={(e) =>
                                        handleRadioChange(
                                          e,
                                          question.ID,
                                          `Option${idx + 1}`,
                                          item
                                        )
                                      }
                                    />
                                    <label className="form-check-label">
                                      {item.option}
                                    </label>
                                  </div>
                                )
                            )}
                            {error[question.ID] && (
                              <div className="text-danger mt-2">
                                {error[question.ID]}
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  ))}

                  {/* Buttons */}
                  <div className="mt-3 text-end">
                    <button
                      type="button"
                      className="cancel-btn me-2"
                      onClick={() => window.history.back()}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="custom-btn"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? (
                        <FaSpinner className="spinner-sm" />
                      ) : (
                        "Submit"
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EmpFeedBackForm;
